<template>
	<div class="p_box" id="box">
		<div id="head">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/Homes' }" replace>首页</el-breadcrumb-item>
				<el-breadcrumb-item :to="{ path: '/Already' }" replace>已做作业</el-breadcrumb-item>
				<el-breadcrumb-item >{{type == 0 ?'未批改':'已批改'}}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>

		<div class="mine_list p_m_t_30 overflow small_hand deatil_not" :style="{ height: height + 'px' }">
			<deatil-not :data="data"></deatil-not>
		</div>

	</div>
</template>

<script>
import DeatilNot from './commponents/deatilNot.vue';
export default {
	name: 'AlreadyDeatil',
	components:{ DeatilNot },
	data() {
		return {
			headerIndex: 0,
			height: 0,
			type:0,
            data: { list:[], job_submit:{}, count:0 },
			postData: { limit:10, page:1, job_submit_id:null },
			isPullLoading: true
		};
	},
	mounted() {
		this.type = this.$route.query.type;
        let jobSubmitID = this.$route.query.jobSubmitID
		this.indexInfo();
		this.postData.job_submit_id = jobSubmitID
		this.getList(this.postData)
		var _this = this
		this.$nextTick(() => {
			var el = document.querySelector('.deatil_not');
			var offsetHeight = el.offsetHeight;
			el.onscroll = () => {
				var scrollTop = el.scrollTop;
				var scrollHeight = el.scrollHeight;
				if ((offsetHeight + scrollTop) - scrollHeight >= -1) {
					if( _this.isPullLoading ){
						_this.postData.page = _this.postData.page+1
						_this.getList(_this.postData)
					}

				}
			};
		});

	},
	watch: {
		'$route.path': {
			immediate: true,
			handler(newVal, oldVal) {
				if (newVal == '/AlreadyDeatil') {
					var height = localStorage.getItem('height');
					if (height == '') {
					} else {
						this.height = height;
					}
				}
			}
		}
	},
	beforeRouteLeave(to, form, next) {
		localStorage.removeItem('height');
		next();
	},
	methods: {
		getList(postData){
			this.$request.ajax(this).post('api_student/exercise_homework_done', postData).then(res=>{
				var list = res.data.list
				if( list.length > 0 ){
					res.data.list = this.data.list.concat(list)
					this.data = res.data
				}else{
					this.isPullLoading = false
					this.data.job_submit = res.data.job_submit
				}

			})
		},

		indexInfo() {
			var box = document.getElementById('box').offsetHeight;
			var head = document.getElementById('head').offsetHeight;
			var height = box - head  - 30;
			var heights = localStorage.getItem('height');
			if (heights == null) {
				localStorage.setItem('height', height);
			} else {
			}
			this.height = height;
		},
	}
};
</script>
<style lang="scss" scoped>
.mine_header {
	background-color: #fafafa;
	height: 60px;
}

.header_left > div {
	height: 100%;
	position: relative;
	margin-left: 260px;
}

.header_left > div:nth-child(2) {
	margin-left: 50px;
}

.header_left {
	height: 100%;
}

.header_heng {
	position: absolute;
	bottom: 0;
	left: 50%;
	transform: translateX(-50%);
	width: 80%;
	height: 2px;
	background-color: #000000;
}
.tababr_com {
	font-weight: bold;
}
.heaer_btn {
	margin-left: 440px;
}
.mine_list {
	padding: 0 60px;
	background-color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/homes/already/deatil.vue